// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {ReactNode, useEffect, useRef} from 'react';
import cn from 'classnames';
import {Link} from 'react-router-dom';
import {use_theme} from '../../../../hola/pub/settings_ctx';
import Icon_chevron_down from '../../img/icons/24/chevron_down_small.svg';
import {Products_menu} from './products';
import {Locations_menu} from './locations';
import styles from './nav_menu.module.less';
import {Resources_menu} from './resources_menu';

type t_toggle = (state?: boolean)=>void;

interface i_menu_item_props {
    id: string;
    to?: string;
    title: string;
    content?: ReactNode;
    toggle?: t_toggle;
}
export const Menu_item = (props: i_menu_item_props)=>{
    const {id, title, content, toggle} = props;
    const {theme} = use_theme({def: 'oculus'});
    const ref = useRef<HTMLDivElement>();
    const content_cls = cn(styles.menu_content);
    const L = !props.to ? 'div' : props.to.startsWith('https://docs')
        ? ({to, ...rest})=><a href={to}
          target="_blank"
          rel="noopener noreferrer"
          {...rest}/>
        : props.to.startsWith('https')
        ? ({to, ...rest})=><a href={to}
          rel="noopener noreferrer"
          {...rest}/>
        : Link;
    useEffect(()=>{
        if (!ref.current)
            return;
        const calc_shift = ()=>{
            const shift = ref.current.getBoundingClientRect().left;
            ref.current.style.setProperty('--left', `${shift}px`);
        };
        calc_shift();
        window.addEventListener('resize', calc_shift);
        return ()=>{
            window.removeEventListener('resize', calc_shift);
        };
    }, [ref.current]);
    return <div className={cn(styles.menu_item, styles[id])} ref={ref}
      onMouseOver={()=>toggle?.(true)} onMouseOut={()=>toggle?.(false)}>
      <div className={styles.menu_link}>
        <L to={props.to} className={cn(theme.P, theme.p3)}
          data-clickid={`nav_${id}`}>{title}</L>
        {content && <Icon_chevron_down className={styles.link_icon}/>}
      </div>
      {content && <div className={content_cls}>{content}</div>}
    </div>;
};

interface i_nav_menu_props {
    visible: boolean;
    toggle: t_toggle;
}
export const Nav_menu = (props: i_nav_menu_props)=>{
    const {visible = true, toggle} = props;
    return <div className={cn(styles.nav_menu, visible && styles.visible)}>
      <Menu_item id="products" title="Products" toggle={toggle}
        to='/products'
        content={<Products_menu variant="info"/>}/>
      <Menu_item id="resources" to="/pricing"
        title="Pricing" toggle={toggle}
        content={<Products_menu variant="pricing"/>}/>
      <Menu_item id="locations" to="/proxy-location"
        title="Locations"
        toggle={toggle} content={<Locations_menu/>}/>
      <Menu_item id="docs" to="https://docs.oculusproxies.com/"
        title="Resources" toggle={toggle}
        content={<Resources_menu/>}/>
    </div>;
};
